import React from "react";
import { MapPin, CheckCircle2, Home } from "lucide-react";
import { PatientAddress } from "./types";

interface AddressCardProps {
  address: PatientAddress;
  isSelected: boolean;
  onSelect: (address: PatientAddress) => void;
}

export const AddressCard: React.FC<AddressCardProps> = ({
  address,
  isSelected,
  onSelect,
}) => {
  return (
    <div
      onClick={() => onSelect(address)}
      className={`p-3.5 rounded-xl border transition-all cursor-pointer flex items-start gap-3 relative ${
        isSelected
          ? "border-emerald-500 bg-emerald-50/40 shadow-sm ring-1 ring-emerald-500"
          : "border-slate-200 bg-white hover:border-slate-300 hover:bg-slate-50/50"
      }`}
    >
      <div
        className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5 ${
          isSelected
            ? "bg-emerald-500 text-white"
            : "bg-slate-100 text-slate-500"
        }`}
      >
        {address.addressName?.toLowerCase() === "home" ? (
          <Home size={16} />
        ) : (
          <MapPin size={16} />
        )}
      </div>

      <div className="flex-1 min-w-0 pr-6">
        <div className="flex items-center gap-2 mb-0.5">
          <span className="text-xs font-bold text-slate-800 capitalize">
            {address.addressName || "Saved Address"}
          </span>
          {address.isDefault && (
            <span className="px-1.5 py-0.2 rounded text-[0.6rem] font-extrabold bg-slate-100 text-slate-600 border border-slate-200 uppercase">
              Default
            </span>
          )}
        </div>
        <p className="text-xs text-slate-600 font-medium leading-relaxed break-words">
          {address.address}
        </p>
        <p className="text-[0.68rem] text-slate-400 font-medium mt-0.5">
          {address.city}, {address.state} — {address.pincode}
        </p>
        {address.landmark && (
          <p className="text-[0.65rem] text-slate-500 italic mt-0.5">
            Landmark: {address.landmark}
          </p>
        )}
      </div>

      <div className="absolute top-3.5 right-3.5">
        <div
          className={`w-4 h-4 rounded-full border flex items-center justify-center transition-colors ${
            isSelected
              ? "border-emerald-500 bg-emerald-500 text-white"
              : "border-slate-300 bg-white"
          }`}
        >
          {isSelected && <CheckCircle2 size={12} />}
        </div>
      </div>
    </div>
  );
};

export default AddressCard;
